import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pageHomeLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.75 })

      tl.to('.hero-home .wrap-fullscreen-video', { opacity: 1 })
      .to('.hero-home .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-home .wrap-hero-header .big-title-home', { opacity: 1 }, '>-0.25')
      .to('.hero-home .wrap-hero-header .secondary-heading', { opacity: 1 }, '>-0.25')
      .to('.hero-home .wrap-hero-header .wrap-hero-links a', { opacity: 1 , stagger: {
        each: 0.08,
        from: 'start',
        grid: 'auto',
        ease: 'linear',
      }}, '>-0.35')
      .to('.hero-home .wrap-logo-left', { opacity: 1 }, '>-0.25')
      .to('.hero-home .wrap-logo-hero .image', { opacity: 1 , stagger: {
        each: 0.05,
        from: 'start',
        grid: 'auto',
        ease: 'linear',
      }}, '>-0.35')
    }
    pageHomeLoadAnimation()

    /**************************************************************
    -> Home intro anim on scroll
    **************************************************************/
    function inViewAnimIntro() {
      gsap.fromTo('.wrap-text-and-landscape h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-home .wrap-text-and-landscape',
      })

      gsap.fromTo('.wrap-text-and-landscape p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-home .wrap-text-and-landscape',
      })

      gsap.fromTo('.wrap-text-and-landscape .link-to' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-home .wrap-text-and-landscape p',
      })

      gsap.fromTo('.wrap-image-portrait' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-home .wrap-text-and-landscape',
      })

      gsap.fromTo('.wrap-text-and-landscape .image' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-home .link-to',
      })

    }
    inViewAnimIntro();

    /**************************************************************
    -> Home Journey anim on scroll
    **************************************************************/
    function inViewAnimJourney() {
      gsap.fromTo('.experiences-home .wrap-text .title-wrap' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.experiences-home',
      })

      gsap.fromTo('.experiences-home .wrap-text p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.experiences-home',
      })

      gsap.fromTo('.experiences-home .wrap-text .link-to' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.experiences-home',
      })

      gsap.fromTo('.experiences-home .wrap-carousel' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.experiences-home .link-to',
      })

    }
    inViewAnimJourney();

    /**************************************************************
    -> Home Destinations anim on scroll
    **************************************************************/
    function inViewAnimDestinations() {
      gsap.fromTo('.destinations-home .wrap-text h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.destinations-home',
      })

      gsap.fromTo('.destinations-home .wrap-text p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.destinations-home',
      })

      gsap.fromTo('.destinations-home .wrap-destinations-list .destination-item' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        ease: 'linear',
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.destinations-home',
      })

    }
    inViewAnimDestinations();

    /**************************************************************
    -> Home News anim on scroll
    **************************************************************/
    function inViewAnimNews() {
      gsap.fromTo('.news-and-press-home .wrap-text h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.news-and-press-home',
      })

      gsap.fromTo('.news-and-press-home .wrap-text .link-to' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.news-and-press-home',
      })

      gsap.fromTo('.news-and-press-home .wrap-news-row .news-item' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        ease: 'linear',
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.news-and-press-home',
      })

    }
    inViewAnimNews();

    /**************************************************************
    -> Home quotes anim on scroll
    **************************************************************/
    function inViewAnimQuote() {
      gsap.fromTo('.clients-say-home h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-home',
      })

      gsap.fromTo('.clients-say-home .wrap-carousel' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-home h2',
      })
    }
    inViewAnimQuote();

    let mql = window.matchMedia('(max-width: 600px)');
    const videoEl = document.querySelector('.wrap-fullscreen-video video');

    if (mql) {
      videoEl.play();
    }

    // eslint-disable-next-line no-unused-vars
    let homeExperiencesSwiper = new Swiper ('.swiper-container-home-experiences', {
      loop: true,
      slidesPerView: 3.5,
      // roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-experiences-button-next',
        prevEl: '.swiper-experiences-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.2,
        },
        // when window width is >= 760px
        760: {
          slidesPerView: 2.2,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3.2,
        },
      },
    })

    // eslint-disable-next-line no-unused-vars
    let homeQuoteSwiper = new Swiper ('.swiper-container-home-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })

    $('.wrap-hero-links a[href^="#boxzilla-"]').click(function(e) {
      e.preventDefault();
      window.location.hash = '#webinars';
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js